import { RichLanguageFormat } from "@dc-extension-rich-text/common";
var conf = {
    format: RichLanguageFormat.TEXT
};
export default conf;
